import React from 'react';
import PropTypes from 'prop-types';
import OnboardingPlanCard from './OnboardingPlanCard';
import { PLATFORM_PLANS } from '../../data/platformPlans';

const OnboardingPlansPanel = ({ onSelectPlan, isLoading, selectedPlanId, errorMessage }) => (
  <div className="onboarding-plans-panel">
    <div className="onboarding-plans-panel__header">
      <h2 className="onboarding-plans-panel__title">Planes</h2>
    </div>

    {errorMessage && <p className="onboarding-plans-panel__error">{errorMessage}</p>}

    <div className="onboarding-plans-panel__grid">
      {PLATFORM_PLANS.map(plan => (
        <OnboardingPlanCard
          key={plan.id}
          plan={plan}
          onSelect={onSelectPlan}
          isLoading={isLoading}
          isSelected={selectedPlanId === plan.id}
        />
      ))}
    </div>
  </div>
);

OnboardingPlansPanel.propTypes = {
  onSelectPlan: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  selectedPlanId: PropTypes.string,
  errorMessage: PropTypes.string
};

OnboardingPlansPanel.defaultProps = {
  isLoading: false,
  selectedPlanId: null,
  errorMessage: ''
};

export default OnboardingPlansPanel;
